import { NumberBox, NumberBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../../state/standardLoanStore';
import { toPositiveNumber } from './functions/toPositiveNumber';

export const InterestRateCeilingField = () => {
    const value = useStandardLoanStore((state) => state.loan.interestRateCeiling);
    const updateLoan = useStandardLoanStore((state) => state.updateLoan);

    return (
        <NumberBox
            id='loanInterestRateCeiling'
            value={value}
            onChange={(rate) => updateLoan({ interestRateCeiling: toPositiveNumber(rate) })}
            label='Interest Rate Ceil.'
            format="#0.##'%'"
            width='100%'
            height='36px'
            layoutStyle={NumberBoxLayoutStyle.Horizontal}
            labelWidth='150px'
        />
    );
};
